import {
  UninitializedPropertyAccessException8qin22n38p0w as UninitializedPropertyAccessException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function throwUninitializedPropertyAccessException(name) {
  throw UninitializedPropertyAccessException().w('lateinit property ' + name + ' has not been initialized');
}
function throwUnsupportedOperationException(message) {
  throw UnsupportedOperationException().a1(message);
}
//region block: exports
export {
  throwUninitializedPropertyAccessException as throwUninitializedPropertyAccessException14fok093f3k3t,
  throwUnsupportedOperationException as throwUnsupportedOperationException2oe5w0ywo7zbr,
};
//endregion

//# sourceMappingURL=ThrowHelpers.mjs.map
